import { defineMessages, MessageDescriptor } from "react-intl";

const validationErrors = defineMessages({
  duplicateDisplayName: {
    id: "settings.manageFields.validationError.duplicateDisplayName",
    defaultMessage:
      "A field with that name already exists on this object, possibly among your archived fields. Archived field names stay reserved, so unarchive that field or pick a different name.",
    description: "Error toast when a custom field name is already taken",
  },
});

// "pg-23505" is the unique-index violation the platform raises for a duplicate display name; v0184
// says the same thing but is no longer emitted, and is kept here in case an older API still does.
type CustomFieldValidationErrorCode = "pg-23505" | "v0184";

// Keyed by the platform code the server raises, so the whole map can be handed to
// getErrorMessage / handleError as messageByErrorCodeMap.
export const customFieldValidationErrorMessages: Readonly<
  Record<CustomFieldValidationErrorCode, MessageDescriptor>
> = {
  "pg-23505": validationErrors.duplicateDisplayName,
  v0184: validationErrors.duplicateDisplayName,
};
